<template>
    <Card :title="$t('crmAnalyticsPage.ordersProfitSumCardTitle')">
        <div class="card-body">
            <StackedColumnChartComponent
                :data="chartData"
                :timeLineRange="timeLineRange"
                :color="['#138937', '#f59e52']"
                measurement="грн."
            />
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue'
import StackedColumnChartComponent from '../../../../../components/chart/StackedColumnChartComponent.vue';

export default {
    name: "OrderProfitSumByCreatedDate",
    components: {
        Card, StackedColumnChartComponent
    },
    props: {
        timeLineRange: {
            type: Array,
            required: false,
            default: () => []
        },
        chartData: {
            type: Object,
            required: false,
            default: () => ({})
        }
    }
}
</script>
